<template>
  <div
    data-test="information-card-event-tee-time"
    class="information-card-event-tee-time"
  >
    <InformationCard
      :read-only="true"
      :heading="`${
        event.type === 'tee_time' ? 'Tee Time' : 'Event'
      } Information`"
    >
      <div
        class="information-card-event-tee-time__info-container body--p1--regular"
      >
        <p
          v-if="event.eventName"
          class="information-card-event-tee-time__info-column1"
        >
          Event
        </p>
        <p
          v-if="event.eventName"
          class="information-card-event-tee-time__info-column2"
        >
          {{ event.eventName }}
        </p>
        <p class="information-card-event-tee-time__info-column1">Location</p>
        <p class="information-card-event-tee-time__info-column2">
          <span>{{ event.clubName }}</span>
          <br />
          <span>{{ event.clubAddress1 }}</span>
          <br />
          <span>{{ event.clubAddress2 }}</span>
        </p>
        <p
          v-if="event.course"
          class="information-card-event-tee-time__info-column1"
        >
          Course
        </p>
        <p
          v-if="event.course"
          class="information-card-event-tee-time__info-column2"
        >
          {{ event.course }}
        </p>
        <p class="information-card-event-tee-time__info-column1">Date</p>
        <p class="information-card-event-tee-time__info-column2">
          {{ event.date }}
          <span v-if="event.dateDescription" class="additional-context">{{ event.dateDescription }}</span>
        </p>
        <p class="information-card-event-tee-time__info-column1">Time</p>
        <p class="information-card-event-tee-time__info-column2">
          {{ event.time }}
          <span v-if="event.timeDescription" class="additional-context">{{ event.timeDescription }}</span>
        </p>
        <p class="information-card-event-tee-time__info-column1">Players</p>
        <p class="information-card-event-tee-time__info-column2">
          {{ players }}
        </p>
        <p
          v-if="event.holes"
          class="information-card-event-tee-time__info-column1"
        >
          Holes
        </p>
        <p
          v-if="event.holes"
          class="information-card-event-tee-time__info-column2"
        >
          {{ event.holes }}
        </p>
      </div>
    </InformationCard>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import InformationCard from '@base/components/InformationCard/InformationCard.vue'
import { EventTeeTime } from './EventTeeTimeType'

export default defineComponent({
  name: 'InformationCardEventTeeTime',
  components: { InformationCard },
  props: {
    event: {
      type: Object as PropType<EventTeeTime>,
      required: true
    },
    players: {
      type: Number,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.information-card-event-tee-time {
  &__info-container {
    column-gap: var(--spacing--4);
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    row-gap: var(--spacing--8);
  }

  &__info-column1 {
    color: var(--color--neutral-a3);
  }

  &__info-column2 {

    span.additional-context {
      display: block;
      color: var(--color--neutral-a3);
    }
  }
}
</style>
